export class SecurityIssue {

  public id: string;
  public type: string;
  public diffType: string;
  public fileName: string;
  public file_path: string;
  public status: string;
  public version: string;
  public slug: string;
  public selected: boolean;

}
